/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

/**
 * Deposit vault DTO
 */
export interface DepositVaultDto {
  id: number;
  account?: Account;
  externalId: string;
  name: string;
  autoSweep: boolean;
  businessEntity: DepositVaultDto.BusinessEntityEnum;
}
export namespace DepositVaultDto {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
